const lang = {
  "common.and": "y",
  "common.or": "o",
  "common.yes": "si",
  "common.delete": "Borrar",
  "common.loading": "Cargando",
  "common.done": "Listo",
  "common.close": "Cerrar",
  "common.continue": "Continuar",
  "common.accept": "Aceptar",
  "common.property": "Propiedad",
  "common.send": "Enviar",
  "common.status": "Estado",
  "common.skip": "Saltar",
  "common.pause": "Pausar",
  "common.edit": "Editar",
  "common.activate": "Activar",
  "common.connecting": "Conectando",
  "common.next": "Siguiente",
  "common.previous": "Anterior",
  "common.back": "Atrás",
  "common.apply": "Aplicar",
  "common.active": "Activo",
  "common.manage": "Gestionar",
  "common.download": "Descargar",
  "common.setup": "Configurar",
  "common.connect": "Conectar",
  "common.regenerate": "Regenerar",
  "common.clear": "Limpiar",
  "common.configure": "Configurar",
  "common.call": "Llamada",
  "common.inactive": "Inactivo",
  "common.cancel": "Cancelar",
  "common.account": "Cuenta",
  "common.file": "Archivo",
  "common.photo": "Fotos",
  "common.emoji": "Emoji",
  "common.runAi": "Correr conversacional",
  "common.remove": "Borrar",
  "common.reset": "Reestablecer",
  "common.confirmInactive": "Si, desactivar",
  "common.confirmContinue": "Sí, eliminar",
  "common.confirmDelete": "Sí, borrar",
  "common.confirmScan": "Sí, escanear",
  "common.error": "Error",
  "common.tryItLater": "Hubo un error, inténtalo más tarde",
  "common.success": "Exitoso",
  "common.today": "Hoy",
  "common.week": "Esta semana",
  "common.7days": "Últimos 7 días",
  "common.30days": "Últimos 30 días",
  "common.thisMonth": "Este mes",
  "common.lastMonth": "Mes pasado",
  "common.custom": "Custom",
  "common.all": "Todos",
  "common.date": "Fecha",
  "common.name": "Nombre",
  "common.company": "Cuenta",
  "common.message": "Mensaje",
  "common.chat": "Chat",
  "common.noResults": "No hay registros para el rango de fechas seleccionado",
  "common.results": "{total} resultados",
  "common.body": "Mensaje",
  "common.tags": "Etiquetas",
  "common.save": "Guardar",
  "common.saveClose": "Guardar y cerrar",
  "common.submitChanges": "Enviar cambios",
  "common.updating": "Actualizando...",
  "common.newConversation": "Nueva conversación",
  "common.create": "Crear",
  "common.phone": "Número de teléfono",
  "common.contactName": "Nombre del contacto",
  "common.optional": "Opcional",
  "common.recommended": "Recomendado",
  "common.signUp": "Registrarse",
  "common.copyLink": "Link copiado",
  "common.copyCode": "Codigo copiado",
  "common.share": "Compartir",
  "common.embed": "Insertar",
  "common.virtualAssistant": "Asistente Virtual",
  "common.scan": "Escanear",
  "common.rescan": "Re-escanear",
  "common.add": "Agregar",
  "common.setUp": "Configurar",
  "common.typeText": "Escribe un texto...",
  "common.connected": "Conectado",
  "common.disconnected": "no conectado",
  "common.searchText": "Buscar en el texto...",
  "common.characteres": "caracteres",
  "common.wordpress": "WordPress",
  "common.seeMessage": "Ver mensaje",
  "common.analyze": "Analizar",
  "common.filter": "Filtrar",
  "common.filterConvs": "Filtrar chats",
  "common.reviewNow": "Revisar ahora",
  "common.analyzedOn": "Último análisis {date}",
  "common.available": "Disponible",
  "common.activeConfig": "Configuración activa",
  "common.invalidDomain":
    "Este sitio web no es válido. Ingresa un dominio permitido.",

  "settings.pageTitle": "Ajustes",
  "settings.pageDescription": "Ajusta tus preferencias",
  "settings.ai": "Ajustes de IA",
  "settings.accountTitle": "Cuenta",
  "settings.language": "Idioma",
  "settings.company": "Información de la empresa",
  "settings.company.desc":
    "Modifica la información de tu empresa, como el nombre",
  "settings.api": "Claves API",
  "settings.settingsTitle": "Ajustes",
  "settings.channels": "Canales",
  "settings.connect": "Conectar",
  "settings.integrations": "Integraciones",
  "settings.teams": "Equipo",
  "settings.payment": "Facturación",
  "settings.usage": "Uso",
  "settings.pushNotificationsDescription":
    "Controla las notificaciones push en tu dispositivo",
  "settings.pushNotificationsDenied":
    "Las notificaciones están desactivadas. Actívalas en los ajustes del dispositivo para recibir avisos.",
  "esc.needsReview": "Revisión",
  "esc.escalation": "Ayuda",
  "esc.clickToView": "Clica para ver",
  "esc.tapToView": "Toca para ver",
  "esc.solve": "Resolver la escalada",
  "support.liveChat": "Chat en Vivo",
  "support.guide": "Leer Guía",
  "support.email": "Escríbenos",
  "support.call": "Agendar Llamada",
  "nav.inbox": "Chats",
  "nav.integrations": "Integraciones",
  "nav.home": "Inicio",
  "nav.outbound": "Eventos",
  "nav.ai": "IA",
  "nav.aiSetup.progress": "Config. {completed}/3",
  "nav.aiSetup.title": "Configuración de cuenta",
  "nav.aiSetup.progressSummary": "{completed} de {total} completados",
  "nav.aiSetup.progressSummary.blocked":
    "{completed} de {total} completados • Conecta un canal para salir en vivo.",
  "nav.aiSetup.popover.title": "Completa la configuración de IA",
  "nav.aiSetup.popover.subtitle": "Completa estos pasos para salir en vivo.",
  "nav.aiSetup.completed.title": "Configuración completada",
  "nav.aiSetup.completed.subtitle":
    "Tu IA ya está en vivo en al menos un canal.",
  "nav.aiSetup.completed.cta": "Ir a Chats",
  "nav.aiSetup.item.knowledge": "Conocimiento",
  "nav.aiSetup.item.knowledge.desc":
    "Así entrenas a tu IA: agrega sitio web, texto o archivos.",
  "nav.aiSetup.item.integrations": "Integraciones",
  "nav.aiSetup.item.integrations.desc":
    "Conecta tu proveedor para enriquecer respuestas.",
  "nav.aiSetup.item.channels": "Canales",
  "nav.aiSetup.item.channels.desc":
    "Conecta al menos un canal para salir en vivo.",
  "nav.aiSetup.item.teamMembers": "Miembros del equipo",
  "nav.aiSetup.item.teamMembers.desc":
    "Invita a tu equipo para que ayude a gestionar conversaciones.",
  "nav.aiSetup.item.mobileApps": "Apps móviles",
  "nav.aiSetup.item.mobileApps.desc":
    "Instala la app de Visito para recibir notificaciones push.",
  "nav.aiSetup.action.go": "Ir",
  "nav.whatsNew.trigger": "Novedades",
  "nav.whatsNew.title": "Novedades en Visito",
  "nav.whatsNew.subtitle": "Actualizaciones recientes para tu equipo.",
  "nav.whatsNew.new": "Nuevo",
  "nav.whatsNew.item.cta": "Abrir",
  "nav.whatsNew.item.setup.title": "Progreso de configuración",
  "nav.whatsNew.item.setup.desc":
    "Sigue tu avance de onboarding directamente desde la barra.",
  "nav.whatsNew.item.playground.title": "Prompts rápidos en Playground",
  "nav.whatsNew.item.playground.desc":
    "Usa prompts sugeridos por contexto para probar tu IA más rápido.",
  "nav.whatsNew.item.team.title": "Miembros del equipo en móvil",
  "nav.whatsNew.item.team.desc":
    "Gestiona invitaciones y roles desde ajustes móviles.",
  "nav.whatsNew.item.mobile.title": "Notificaciones móviles",
  "nav.whatsNew.item.mobile.desc":
    "Instala la app móvil para no perder nuevas conversaciones.",
  "nav.whatsNew.item.itemsCatalog.title": "Catálogo de ítems para ventas directas",
  "nav.whatsNew.item.itemsCatalog.desc":
    "Crea ítems como pasadías o masajes, agrega detalles obligatorios y deja que la IA cobre con links de pago en el chat.",
  "nav.whatsNew.item.followUps.title": "Controles de seguimiento",
  "nav.whatsNew.item.followUps.desc":
    "Ahora puedes definir cuánto espera la IA antes de revisar chats inactivos y qué tan agresivo será el seguimiento (Alta, Predeterminada o Baja) según el impacto de la conversación.",
  "nav.whatsNew.item.igDocs.title": "Envío de documentos en Instagram",
  "nav.whatsNew.item.igDocs.desc":
    "Ahora puedes enviar documentos desde Visito a Instagram como adjuntos en el chat.",
  "nav.whatsNew.item.mobileTeam.title":
    "Gestiona miembros del equipo desde la app",
  "nav.whatsNew.item.mobileTeam.desc":
    "Invita y administra a tu equipo directamente desde Visito móvil.",
  "nav.whatsNew.item.mobileTeam.android": "Descargar para Android",
  "nav.whatsNew.item.mobileTeam.ios": "Descargar para iOS",
  "nav.menu": "Menu",
  "nav.crm": "CRM",
  "nav.leads": "Leads",
  "nav.channels": "Canales",
  "nav.payments": "Pagos",
  "nav.items": "Ítems",
  "nav.settings": "Ajustes",
  "nav.logout": "Salir",
  "nav.notificationsToolTip":
    "Controla los sonidos de alerta y las notificaciones de escritorio.",

  "nav.notifications": "Notificaciones",

  "nav.channelOnboarding": "¿Necesitas ayuda?",
  "nav.channelOnboardingCTA": "Agenda una llamada",
  "nav.limitApproaching": "Tus créditos están por agotarse.",
  "nav.payment": "Has usado todos tus créditos de mensajes.",
  "nav.paymentCTA": "Obtener más créditos",
  "nav.pastDue": "Su pago falló.",
  "nav.pastDueCTA":
    "Actualice su método de pago para mantener su cuenta activa.",
  "nav.accountList": "Cuentas",
  "nav.connect": "Conectar",
  "nav.createAccount": "Crear nueva cuenta",
  "nav.helpCenter": "Centro de ayuda",
  "nav.helpChat": "Chat de ayuda",
  "ai-settings.workingHours": "Horario de Trabajo",
  "ai-settings.workingHoursDescription":
    "Si una escalación ocurre fuera del horario laboral, la IA informará al huésped sobre el horario de atención.",
  "ai-settings.title": "Ajustes de IA",
  "ai-settings.paneTitle": "Configuración de Inteligencia Artificial",
  "ai-settings.notifications": "Notificaciones",
  "ai-settings.notificationsDescription":
    "Descarga la aplicación Visito y recibe notificaciones push para conversaciones no resueltas.",
  "ai-settings-intructions.title": "Ajustes",
  "ai.pageTitle": "Inteligencia Artificial",
  "ai.pageDescription": "Ajusta y experimenta con tu agente de IA",
  "ai.contextTitle": "Base de Conocimiento",
  "ai.contextDescription":
    "Gestiona tus conocimientos para entrenar a tu agente de IA",
  "ai.playgroundTitle": "Sandbox del Agente de IA",
  "ai.playgroundDescription":
    "Interactúa con tu agente de IA para observar cómo responde",
  aiSettingsWorking: "Estamos preparando tu información",
  aiSettingsOptimizing: "Estamos optimizando tu información",
  aiSettingsOptimizingDesc:
    "Estamos optimizando la información extraída de su sitio web",
  aiSettingsKnowledge: "Hub de IA",
  aiSettingsKnowledgeDesc:
    "Aquí puede proporcionar información para entrenar la IA. Pruebe la IA de la derecha para ver qué experimentarán sus clientes.",
  aiSettingsAlert:
    "Aquí puede proporcionar información para entrenar la IA. Pruebe la IA de la derecha para ver qué experimentarán sus clientes.",
  aiSettingsFreeText: "Texto libre",

  aiSettingsReset: "Limpiar",
  aiSettingsCall: "Llamar",
  aiSettingsCalling: "Llamando",
  aiSettingsCallConnected: "Conectado",
  aiSettingsMicPermission: "Permite el acceso al micrófono para continuar",

  aiSettingsHangup: "Colgar",
  aiSettingsAssitant: "¡Conoce a Lana! Tu asistente virtual",
  aiSettingsAssitantDesc:
    "Aquí es donde puede experimentar e interactuar con Lana para comprender exactamente qué experimentarán sus clientes con las respuestas de la IA.",
  aiCrawlingFailed:
    "Hubo un problema al analizar tu sitio web, inténtalo más tarde",
  aiCrawlingSkip: "¿Quieres continuar sin analizar tu sitio web?",
  aiCrawlingSkipDesc:
    "Analizar tu sitio web ayudará a tu asistente de IA a ofrecerte mejores resultados",
  aiSettingsSaving: "Guardando cambios...",
  aiExceededLength: "Excediste la longitud de caracteres",
  aiCompanyTitle: "{company}",
  aiPoweredBy: "Desarrolado por",
  aiCompanyWelcomeTitle: "Bienvenido al asistente virtual de {company}",
  aiCompanyFormDesc: "Introduce tu nombre para empezar",
  aiCompanyExplore: "Continuar",
  aiShare: "Comparte tu asistente virtual",
  aiCrawl: "¡Escaneemos su sitio web y entrenemos a su agente de IA!",
  aiCrawling: "Tu IA está rastreando el sitio web",
  aiCrawlingWebsiteSucc: "Análisis del sitio web completado",
  aiCrawlingSuccess: "Su sitio web se rastreo exitosamente",
  aiCrawlingSuccessDesc: "Su información esta lista para su revisión.",
  aiReview: "Revisémoslo",
  aiAgent: "Agente de IA",
  aiAgentCreated: "Tu agente de IA está listo",
  aiUpdateCta: "Editar",
  aiUpdateSucces: "Tu agente de IA se ha actualizado",
  aiGeneralContext: "Información General",
  aiProviderContext: "Información del Proveedor",

  "ai.agent.title": "Tu Agente de IA",
  "ai.agent.description":
    "Este es el núcleo central. Su trabajo es conectar todas las piezas de tu ecosistema en tiempo real:",

  "ai.agent.feature.knowledge":
    "Consulta tu base de conocimiento para encontrar respuestas.",
  "ai.agent.feature.behavior":
    "Obedece tu configuración de personalidad, tono de voz y reglas de negocio.",
  "ai.agent.feature.integrations":
    "Ejecuta acciones externas como consultar disponibilidad.",
  "ai.agent.feature.channels":
    "Entrega la respuesta final al cliente a través de tus canales.",
  "ai.onboarding.profile.title": "Cuéntanos sobre ti",
  "ai.onboarding.profile.desc":
    "Introduce tu nombre y número de teléfono para configurar tu cuenta",
  "ai.onboarding.profile.phoneNumber": "Número de teléfono",
  "ai.onboarding.profile.invalidPhone":
    "Por favor, introduce un número de teléfono válido",
  "ai.onboarding.profile.name": "Nombre completo",
  "ai.onboarding.title": "Crea tu agente de IA",
  "ai.onboarding.desc":
    "Proporciona tu sitio web para que la IA aprenda sobre tu negocio.",
  "ai.onboarding.cta": "Crear Agente",
  "ai.onboarding.cta.skip": "Saltar, configurar manualmente",
  "ai.onboarding.sourceNotice": "Puedes añadir mas fuentes de datos más tarde.",
  "ai.onboarding.readingWebsite": "Leyendo tu sitio web",
  "ai.onboarding.teachingAgent": "Enseñando a tu agente",
  "ai.onboarding.creatingAgent": "Preparando tu agente",
  "ai.onboarding.error":
    "No pudimos escanear tu sitio web. Intenta nuevamente con otra URL o continúa con configuración manual.",
  "ai.onboarding.preview.support":
    "¡Hola! 👋 Estoy aquí para ayudarte con cualquier duda o problema. ¿Qué necesitas hoy?",
  "ai.onboarding.preview.sales":
    "¡Hola! 👋 ¿Buscas las mejores ofertas? Puedo mostrarte opciones que se ajusten a lo que necesitas. 🚀",
  "ai.onboarding.preview.booking":
    "Bienvenido 👋 ¿Quieres revisar disponibilidad, hacer una reservación o pedir asistencia? Estoy aquí para ayudarte. 🛎️",
  "ai.onboarding.preview.ecommerce":
    "Hola 👋 ¿Buscas algo en especial? Puedo ayudarte a encontrar el producto ideal para ti. 🛍️",
  "ai.onboarding.preview.internal":
    "Hola equipo 👋 ¿Necesitan apoyo con procesos internos o información específica? Estoy aquí para ayudar.",
  "ai.onboarding.preview.education":
    "Hola 👋 ¿Qué tema te gustaría aprender o repasar hoy? Puedo explicártelo paso a paso. 🎓",
  "ai.onboarding.preview.other":
    "Hola 👋 Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?",
  "ai.onboarding.agent.preview": "Así verán tus clientes a tu agente",
  "ai.onboarding.agent.learn": "Aprenderé de: ",
  "ai.onboarding.agent.online": "En línea",
  "ai.onboarding.agent.processing": "Procesando",
  "ai.onboarding.building": "Construyendo tu Agente",
  "ai.onboarding.type.description":
    "Define cómo tu agente ayudará a tu negocio.",
  "ai.onboarding.company.description":
    "Revisa y edita el contexto de tu empresa antes de crear tu agente.",
  "ai.onboarding.companyName.label": "Nombre de la empresa",
  "ai.onboarding.companyName.placeholder": "VISITO AI",
  "ai.onboarding.companyName.required":
    "El nombre de la empresa es obligatorio.",
  "ai.onboarding.aboutCompany.label": "Sobre la empresa",
  "ai.onboarding.aboutCompany.placeholder":
    "Resume qué hace tu empresa, tus productos/servicios y tu propuesta de valor.",
  "ai.onboarding.aboutCompany.required":
    "La descripción de la empresa es obligatoria.",
  "ai.onboarding.company.contextHelp":
    "Tu agente se entrenará con estos datos. Puedes agregar más contexto después.",
  "ai.onboarding.type.title": "¿Qué quieres que haga tu agente?",
  "ai.onboarding.type.support.label": "Atención al Cliente",
  "ai.onboarding.type.support.desc": "Resuelve dudas frecuentes 24/7.",
  "ai.onboarding.type.sales.label": "Ventas y Leads",
  "ai.onboarding.type.sales.desc": "Captura y califica clientes potenciales.",
  "ai.onboarding.type.booking.label": "Reservas",
  "ai.onboarding.type.booking.desc": "Gestiona agenda y disponibilidad.",
  "ai.onboarding.type.ecommerce.label": "Asistente de Compras",
  "ai.onboarding.type.ecommerce.desc": "Guía sobre productos y catálogo.",
  "ai.onboarding.type.internal.label": "Uso Interno / RRHH",
  "ai.onboarding.type.internal.desc": "Manuales, procesos y dudas de equipo.",
  "ai.onboarding.type.education.label": "Educación",
  "ai.onboarding.type.education.desc": "Explica cursos o temarios.",
  "ai.onboarding.type.other.label": "Otro / Personalizado",
  "ai.onboarding.type.other.desc": "Define tus propias reglas.",
  "ai.onboarding.extraPlaceholder":
    "Describe cómo quieres que funcione tu agente (opcional",
  "ai.viz.title": "Entrenamos tu agente con tu sitio web",
  "ai.viz.description": "La IA aprende de tu contenido para responder mejor",

  "ai.agent": "Tu Agente de IA",
  "ai.agent.update": "Aplicar Cambios",
  "ai.playground": "Prueba",
  "ai.playground.onboarding": "Probar",
  "ai.playground.desc":
    "Pon a prueba tu IA en un chat de prueba igual que en una conversación real.",
  "ai.playground.trained": "Tu IA está lista",
  "ai.playground.notTrained":
    "Tu IA aún no está entrenada. Agrega fuentes de entrenamiento para que pueda comenzar a responder preguntas sobre tu negocio",

  "ai.playground.help.title": "Playground",
  "ai.playground.help.subtitle":
    "Interactúa con tu agente tal como lo harán tus clientes.",
  "ai.playground.help.status.title": "Sincronizado y listo",
  "ai.playground.help.status.desc":
    "El agente tiene acceso total a tu Base de Conocimiento, tu Comportamiento y tus Integraciones activas.",
  "ai.playground.help.suggestions.title": "Sugerencias de interacción",
  "ai.playground.help.suggestions.accuracy.title": "Precisión de respuesta",
  "ai.playground.help.suggestions.accuracy.desc":
    "Pregunta por datos específicos (precios, políticas, horarios) para validar sus fuentes.",
  "ai.playground.help.suggestions.tone.title": "Estilo y tono",
  "ai.playground.help.suggestions.tone.desc":
    "Verifica que se comunique con la personalidad y el formato que definiste en la configuración de comportamiento.",
  "ai.playground.help.suggestions.logic.title": "Lógica y acciones",
  "ai.playground.help.suggestions.logic.desc":
    "Valida que identifique intenciones complejas, ejecute reglas de negocio o active una escalación si es necesario.",
  "ai.playground.help.footer":
    "Si ajustas la configuración, recuerda limpiar el chat para aplicar los cambios.",
  "ai.playground.welcome.connect.title": "Sal a producción más rápido",
  "ai.playground.welcome.connect.subtitle":
    "Conecta canales e integraciones para lanzar tu IA en conversaciones reales.",
  "ai.playground.welcome.connect.channels.desc":
    "Conecta donde tus clientes escriben: WhatsApp, Instagram, Messenger.",
  "ai.playground.welcome.connect.integrations.desc":
    "Conecta proveedores para que tu IA responda con datos del negocio en vivo.",
  "ai.playground.welcome.connect.status.connected": "Conectado",
  "ai.playground.welcome.connect.status.notConnected": "No conectado",
  "ai.playground.welcome.next.title": "¿Listo para el siguiente paso?",
  "ai.playground.welcome.next.subtitle":
    "Completa estos pasos para terminar la configuración y empezar a operar.",
  "ai.playground.welcome.next.toggle": "Mostrar u ocultar siguientes pasos",
  "ai.playground.welcome.next.configure.title": "Configura tu agente de IA",
  "ai.playground.welcome.next.configure.desc":
    "Agrega contexto, reglas y flujos.",
  "ai.playground.welcome.next.configure.cta": "Configurar",
  "ai.playground.welcome.next.channels.title": "Despliega tu IA",
  "ai.playground.welcome.next.channels.desc":
    "Lánzala donde tus clientes te escriben.",
  "ai.playground.welcome.next.channels.cta": "Desplegar",
  "ai.playground.welcome.next.integrations.title": "Conecta tus sistemas",
  "ai.playground.welcome.next.integrations.desc":
    "Toma acciones y comparte datos en vivo.",
  "ai.playground.welcome.next.integrations.cta": "Conectar",
  "ai.playground.welcome.paywall.title": "Activa tu prueba gratis",
  "ai.playground.welcome.paywall.desc":
    "Elige el mejor plan y desbloquea canales, integraciones y flujos avanzados de IA.",
  "ai.playground.welcome.paywall.perMonth": "/ mes",
  "ai.playground.welcome.paywall.creditOptions": "Opciones de créditos",
  "ai.playground.welcome.paywall.creditsOption":
    "{credits, number} créditos / mes",
  "ai.playground.welcome.paywall.includes": "Incluye:",
  "ai.playground.welcome.paywall.mostPopular": "Más popular",
  "ai.playground.welcome.paywall.starter.title": "Starter",
  "ai.playground.welcome.paywall.starter.desc":
    "Soporte y reservas con IA en todos tus canales de mensajería.",
  "ai.playground.welcome.paywall.starter.feature.1":
    "Agente de IA para soporte y reservas",
  "ai.playground.welcome.paywall.starter.feature.2":
    "WhatsApp, Instagram y chat web",
  "ai.playground.welcome.paywall.starter.feature.3":
    "Bandeja de equipo compartida",
  "ai.playground.welcome.paywall.starter.feature.4":
    "Integraciones profundas",
  "ai.playground.welcome.paywall.starter.feature.5":
    "Disponible en más de 100 idiomas",
  "ai.playground.welcome.paywall.starter.feature.6":
    "Analítica básica",
  "ai.playground.welcome.paywall.pro.title": "Pro",
  "ai.playground.welcome.paywall.pro.desc":
    "Modelos avanzados, analítica más profunda y onboarding dedicado.",
  "ai.playground.welcome.paywall.pro.includes": "Todo lo de Starter, más:",
  "ai.playground.welcome.paywall.pro.feature.1":
    "Acceso a modelos avanzados",
  "ai.playground.welcome.paywall.pro.feature.2": "Onboarding dedicado",
  "ai.playground.welcome.paywall.pro.feature.3": "Soporte prioritario",
  "ai.playground.welcome.paywall.pro.feature.4":
    "Analítica y reportes avanzados",
  "ai.playground.welcome.paywall.pro.feature.5":
    "Flujos de IA personalizados",
  "ai.playground.welcome.paywall.pro.feature.6":
    "Quitar marca Visito",
  "ai.playground.welcome.paywall.enterprise.title": "Enterprise",
  "ai.playground.welcome.paywall.enterprise.desc":
    "Flujos e integraciones a medida para negocios en crecimiento.",
  "ai.playground.welcome.paywall.enterprise.custom": "Custom",
  "ai.playground.welcome.paywall.enterprise.includes":
    "Todo lo de Pro, más:",
  "ai.playground.welcome.paywall.enterprise.feature.1":
    "Paquetes de créditos personalizados",
  "ai.playground.welcome.paywall.enterprise.feature.2":
    "Onboarding y diseño de flujos personalizados",
  "ai.playground.welcome.paywall.enterprise.feature.3":
    "Soporte dedicado y opciones SLA",
  "ai.playground.welcome.paywall.enterprise.feature.4":
    "Integraciones personalizadas",
  "ai.playground.welcome.paywall.enterprise.feature.5":
    "Gestión multi-propiedad",
  "ai.playground.welcome.paywall.enterprise.cta": "Solicitar cotización",
  "ai.playground.welcome.paywall.enterprise.intent.channels": "canales",
  "ai.playground.welcome.paywall.enterprise.intent.integrations":
    "integraciones",
  "ai.playground.welcome.paywall.enterprise.mail.subject":
    "Consulta enterprise desde welcome ({intent})",
  "ai.playground.welcome.paywall.enterprise.mail.body":
    "Hola equipo,\n\nQuiero precios enterprise para {company}. Actualmente me interesan {intent}.\n\nCompártanme los detalles, por favor.\n",
  "ai.playground.welcome.paywall.cta": "Comenzar gratis",
  "ai.playground.welcome.paywall.creditsInfo.title":
    "Cómo funcionan los créditos",
  "ai.playground.welcome.paywall.creditsInfo.body":
    "1 crédito = 1 respuesta de tu agente de IA. Los mensajes de clientes y las respuestas manuales de tu equipo siempre son gratis.",
  "ai.playground.starters.label": "Prueba con...",
  "ai.playground.starters.hint":
    "Haz clic en una sugerencia para enviarla al instante.",
  "ai.playground.starters.companyFallback": "tu negocio",
  "ai.playground.starters.channel.whatsapp": "WhatsApp",
  "ai.playground.starters.channel.instagram": "Instagram",
  "ai.playground.starters.channel.messenger": "Messenger",
  "ai.playground.starters.prompt.company":
    "¿Qué hace {company} y quién es su cliente ideal?",
  "ai.playground.starters.prompt.knowledge.ready":
    "¿Qué información ya conoces sobre {company} según mis fuentes de entrenamiento?",
  "ai.playground.starters.prompt.knowledge.missing":
    "¿Qué información clave debería agregar primero para que respondas mejor sobre {company}?",
  "ai.playground.starters.prompt.provider.ready":
    "Un cliente quiere reservar. ¿Cómo lo guiarías paso a paso?",
  "ai.playground.starters.prompt.provider.missing":
    "Si alguien quiere reservar ahora, ¿cómo deberías responder sin un proveedor conectado?",
  "ai.playground.starters.prompt.channels.ready":
    "Muéstrame una respuesta ideal al primer mensaje de {channels}.",
  "ai.playground.starters.prompt.channels.missing":
    "Escribe una respuesta inicial sólida para una nueva consulta de cliente.",
  "ai.playground.starters.prompt.context.whatIs": '¿Qué es "{topic}"?',
  "ai.playground.starters.prompt.context.tellMeMore":
    '¿Puedes contarme más sobre "{topic}"?',
  "ai.playground.starters.prompt.context.howWorks":
    '¿Cómo funciona "{topic}"?',

  "ai.connect.title": "Conectar",
  "ai.connect.desc":
    "Conecta tu IA a un canal como WhatsApp, Instagram o Messenger.",
  "ai.connect.status": "Tu IA no está conectada a ningún canal",
  "ai.connect.cta": "Conectar tu IA",
  "ai.playground.test": "Prueba tu IA",
  "ai.source.active": "Fuente activa",
  "ai.source.inactive": "Fuente no configurada",
  "ai.sources.flow": "Así funciona tu agente de IA",
  "ai.sources.flow.desc":
    "Tus fuentes alimentan al agente. Él usa tus reglas e integraciones para responder en todos tus canales.",
  "ai.sources.agent": "Tu agente de IA",
  "ai.sources.agent.desc": "Centraliza, procesa y responde.",
  "ai.sources": "Fuentes de entrenamiento",
  "ai.sources.onboarding": "Entrenar",
  "ai.sources.alert": "Entrena tu IA",
  "ai.sources.alert.desc":
    "Agrega contenido para que tu agente aprenda sobre tu negocio. Súbelo en segundos: tu website, texto o archivos.",
  "ai.sources.alert.button": "Entendido",
  "ai.sources.desc":
    "Tu IA aprende del contentido de estas fuentes para responder preguntas sobre tu negocio.",
  "ai.sources.website": "Sitio Web",
  "ai.sources.website.desc":
    "Extrae contenido de todo un sitio web o de una URL específica para entrenar tu IA",
  "ai.sources.website.scanning": "Análisis del sitio web en curso",
  "ai.sources.website.scanning.info":
    "Estamos analizando tu sitio web. Esto puede tardar algunos minutos, pero mientras tanto puedes agregar más fuentes o probar tu IA",
  "ai.sources.website.completed": "Análisis del sitio web completado",
  "ai.sources.website.rescan.confirmation":
    "¿Estás seguro de que deseas volver a escanear este sitio web?",
  "ai.sources.website.rescan.confirmationDesc":
    "Volver a escanear este sitio web eliminará todo el contenido extraído previamente y lo reemplazará con nueva información del último escaneo",
  "ai.sources.website.delete.confirmation":
    "¿Estás seguro de que deseas eliminar esta URL?",
  "ai.sources.website.delete.confirmationDesc":
    "Eliminar esta URL eliminará su contenido de la base de conocimientos de tu agente de IA. Ya no se usará para generar respuestas",
  "ai.sources.website.fullCrawl":
    "Esto extraerá contenido de todos los enlaces que comiencen con la URL anterior",
  "ai.sources.website.fullCrawlTitle": "Sitio web completo",
  "ai.sources.website.singleCrawlTitle": "Página específica",
  "ai.sources.website.singleCrawl":
    "Esto extraerá solo el contenido de la URL específica que aparece arriba",
  "ai.sources.website.max":
    "Alcanzaste el límite de {limit} URLs activas. Elimina o desactiva una para poder agregar otra",
  "ai.sources.text": "Texto",
  "ai.sources.text.desc":
    "Agrega texto libre para enseñar a tu IA nuevos detalles o aclarar información sobre tu negocio",
  "ai.sources.text.tip.title":
    "Agrega texto como si se lo explicaras a un compañero.",
  "ai.sources.text.tip.examples":
    "Por ejemplo:\n- Nuestro horario de atención es de lunes a viernes, de 9 AM a 6 PM.\n- Para solicitar soporte, los clientes deben proporcionarnos su número de pedido y correo electrónico.",
  "ai.textHelp.title": "Sugerencias de Contenido",
  "ai.textHelp.intro":
    "Este espacio es ideal para información que no está en tu sitio web o archivos.",
  "ai.textHelp.faqs.title": "Preguntas Frecuentes (FAQs)",
  "ai.textHelp.faqs.desc":
    "Copia y pega pares de Pregunta-Respuesta que tus clientes hacen siempre.",
  "ai.textHelp.specific.title": "Datos Específicos",
  "ai.textHelp.specific.desc":
    "Listas de precios, horarios de apertura, políticas de cancelación.",
  "ai.textHelp.format.title": "Formato Claro",
  "ai.textHelp.format.desc":
    "Usa títulos y listas con viñetas. A la IA le es más fácil leer estructuras ordenadas.",
  "ai.textHelp.tip":
    "Tip: No necesitas redactar como un humano. Datos crudos y directos funcionan mejor.",

  "ai.instructionsHelp.title": "Definiendo tu agente",
  "ai.instructionsHelp.intro":
    "Aquí defines la identidad y las reglas del juego. Piensa en esto como la descripción de puesto de tu nuevo empleado digital.",
  "ai.instructionsHelp.role.title": "Rol y objetivo",
  "ai.instructionsHelp.role.desc":
    'Dile quién es y qué debe lograr. Ejemplo: "Eres un concierge experto en turismo y tu meta es vender tours."',
  "ai.instructionsHelp.tone.title": "Tono de voz",
  "ai.instructionsHelp.tone.desc":
    "¿Cómo debe hablar? Define si quieres un trato formal y serio, o amigable y casual con uso de emojis.",
  "ai.instructionsHelp.rules.title": "Reglas y límites",
  "ai.instructionsHelp.rules.desc":
    'Define instrucciones estrictas. Ejemplo: "Nunca inventes precios", "Responde siempre en español", "No hables de política."',
  "ai.instructionsHelp.tip":
    "Tip: Sé específico. Si quieres respuestas cortas (menos de 50 palabras), escríbelo aquí de forma explícita.",

  "ai.sources.files": "Archivos",
  "ai.sources.files.desc":
    "Sube archivos para enseñar a tu IA. Tu IA no compartirá estos archivos; solo se usan como base de conocimiento para generar respuestas.",
  "ai.sources.files.upload": "Subir Archivo",
  "ai.sources.files.upload.label": "Sube una imagen, PDF o archivo CSV",
  "ai.sources.files.delete": "Eliminar Archivo",
  "ai.sources.files.delete.confirmation":
    "¿Estás seguro de que deseas eliminar este archivo?",
  "ai.sources.files.delete.confirmationDesc":
    "Eliminar este archivo lo eliminará de la base de conocimientos de tu agente de IA. Ya no se usará para generar respuestas.",
  "ai.sources.files.analyzed": "Archivos Analizados",
  "ai.sources.files.limit": "El archivo es demasiado grande. Límite: 15 MB",
  "ai.sources.files.max":
    "El límite de archivos activos es de {limit}. Por favor elimina o desactiva uno para poder subir un nuevo archivo",
  "ai.sources.providers": "Integraciones",
  "ai.sources.providers.desc":
    "Conecta integraciones externas para dar acceso a tu IA a datos adicionales y mejorar sus respuestas",
  "ai.sources.providers.manage":
    "Administra tus integraciones conectadas desde la página de integraciones. Puedes agregarlas, actualizarlas o eliminarlas en cualquier momento.",
  "ai.sources.providers.empty":
    "Aún no tienes integraciones conectadas. Agrega una desde la página de integraciones para comenzar a usar datos externos.",
  "ai.sources.providers.setUp": "Configura una Integración",
  "ai.sources.channels": "Canales",
  "ai.sources.channels.desc":
    "Conecta tu asistente a los principales canales y fuentes de información.",

  "ai.sidebar.sources": "Conocimiento",
  "ai.sidebar.behavior": "Comportamiento",
  "ai.sidebar.connections": "Conexiones",
  "ai.sidebar.agent.active": "Agente Activo",
  "ai.sidebar.agent.active.desc": "Tu IA está lista. Ir al inicio.",
  "ai.sidebar.agent.setup": "Configura tu agente",
  "ai.sidebar.agent.setup.desc": "Añade una fuente.",
  "ai.home.improve.title": "Mejorar respuestas",
  "ai.home.improve.subtitle":
    "Opcional, pero recomendado para mejorar calidad y cobertura.",
  "ai.home.improve.knowledge.desc":
    "Entrena tu IA con más fuentes de información del negocio.",
  "ai.home.improve.integrations.desc":
    "Conecta proveedores para enriquecer respuestas con datos.",

  "ai.sources.customerContext": "Contexto del Cliente",
  "ai.sources.customerContext.desc":
    "Agrega información que solo se incluirá en las respuestas cuando haya una reservación o pedido confirmado. Úsalo para proporcionar detalles como números de habitación, contraseñas de Wi-Fi o códigos de acceso especiales",
  "ai.settings": "Configuración",
  "ai.settings.desc":
    "Ajusta el comportamiento, la personalidad y las reglas de escalación",
  "ai.settings.cta": "Ajustes de la IA",
  "ai.settings.instructions": "Reglas y Tono",
  "ai.settings.instructions.desc":
    "Ajusta el tono y el comportamiento del agente. No agrega conocimiento, solo guía cómo responde.",
  "ai.settings.escalations": "Escalaciones",
  "ai.settings.escalations.desc":
    "Define qué situaciones activan una escalación. Si un usuario pide ayuda o envía un comprobante de pago, la IA dejará de responder y tu equipo será notificado.",
  "ai.settings.escalations.enable": "Escalaciones activas",
  "ai.settings.escalations.disabled": "Escalaciones desactivadas",
  "ai.settings.escalations.disabled.alert":
    "Activa las escalaciones para gestionar tus reglas personalizadas",
  "ai.settings.escalations.enable.desc":
    "Cuando está activado, el agente de IA pausa su respuesta y notifica a tu equipo cada vez que se activa una regla.",
  "ai.settings.escalations.setup": "Configuración de escalaciones",
  "ai.settings.escalations.setup.desc":
    "Elige qué debe hacer el agente de IA en situaciones especiales.",
  "ai.settings.escalations.rules.name": "Nombre de la regla",
  "ai.settings.escalations.rules.content": "Palabra clave / frase",
  "ai.settings.escalations.rules.add": "Agregar regla",
  "ai.settings.escalations.rules.create": "Guardar regla",
  "ai.settings.escalations.rules.new": "Nueva regla de escalación",
  "ai.settings.escalations.rules.description": "Palabras clave / Frase",
  "ai.settings.escalations.rules.details":
    "Escribe una palabra o frase que podría usar el huésped",
  "ai.settings.escalations.rules.build": "Reglas predefinidas",
  "ai.settings.escalations.rules.custom": "Reglas personalizadas",
  "ai.settings.escalations.rules.delete.title":
    "¿Estás seguro de que quieres eliminar esta regla?",
  "ai.settings.escalations.rules.delete.desc":
    "Eliminar esta regla evitará que este tipo de escalación se active nuevamente.",
  "ai.settings.workingHours": "Horario de atención",
  "ai.settings.workingHours.desc":
    "Si ocurre una escalación fuera de este horario, el agente de IA avisará al usuario que estamos fuera de línea antes de notificar a tu equipo.",
  "ai.settings.workingHours.enable": "Horario de atención activado",
  "ai.settings.workingHours.disabled": "Horario de atención desactivado",

  "ai.settings.followUps": "Seguimiento Inteligente",
  "ai.settings.followUps.desc":
    "Envía seguimientos automáticos cuando un usuario queda inactivo. La IA analiza el contexto y solo los envía cuando corresponde.",
  "ai.settings.followUps.enable": "Seguimientos activados",
  "ai.settings.followUps.enable.desc":
    "Cuando está activado, el agente de IA puede hacer un seguimiento con usuarios inactivos, si lo considera necesario.",
  "ai.settings.followUps.disabled": "Seguimientos desactivados",
  "ai.settings.followUps.delay": "Tiempo de seguimiento",
  "ai.settings.followUps.delay.desc":
    "Elige cuánto tiempo esperar antes de evaluar y enviar un seguimiento.",
  "ai.settings.followUps.delay.option.half": "0.5h",
  "ai.settings.followUps.delay.option.hours": "{hours}h",
  "ai.settings.followUps.likelihood": "Probabilidad de seguimiento",
  "ai.settings.followUps.likelihood.desc":
    "Controla qué tan estricta es la IA antes de enviar un seguimiento.",
  "ai.settings.followUps.likelihood.high": "Alta",
  "ai.settings.followUps.likelihood.default": "Predeterminada",
  "ai.settings.followUps.likelihood.low": "Baja",
  "ai.settings.aiBookings": "Reservas de IA",

  "ai.settings.aiBookings.enable": "Reservas de IA activadas",
  "ai.settings.aiBookings.enable.desc":
    "Cuando está activado, el agente de IA puede gestionar reservas y pagos.",
  "ai.settings.aiBookings.disabled": "Reservas de IA desactivadas",
  "ai.settings.aiBookings.connectedAccount": "Cuenta conectada de Stripe",
  "ai.settings.aiBookings.depositPercentage":
    "Depósito requerido como porcentaje del total de la reserva (%). 100 significa pago completo por adelantado.",
  "ai.settings.aiBookings.desc":
    "Las reservas de IA permiten a tu agente gestionar reservas y pagos automáticamente. Configura los detalles de tu cuenta conectada de Stripe y el porcentaje de depósito requerido.",

  "account.successAdded":
    "La invitación ha sido aceptada y ahora tienes acceso a la cuenta.",
  "account.acceptInvitation.title": "Aceptar Invitaciones",
  "account.acceptInvitation.pageDescription":
    "Por favor, acepta tus invitaciones pendientes.",
  "account.acceptInvitation.account": "Nombre de la cuenta",
  "account.acceptInvitation.noPending":
    "No tienes niguna invitación pendiente...",

  "account.createAccount.title": "Crear una nueva cuenta",
  "account.createAccount.pageDescription":
    "Ingresa el nombre de la empresa para la nueva cuenta",
  "channels.title": "Canales",
  "channels.account": "Cuenta",
  "channels.autoReplies": "Respuestas automáticas de IA",
  "channels.waTitle": "Conecta los números de WhatsApp de tu empresa",
  "channels.waDescription":
    "Automatiza conversaciones de WhatsApp o responde manualmente en chat en vivo",
  "channels.igTitle": "Conecta tu cuenta de Instagram",
  "channels.igDescription":
    "Automatiza mensajes de la bandeja de entrada o responde manualmente en chat en vivo.",
  "channels.fmTitle": "Conecta Facebook Messenger",
  "channels.fmDescription":
    "Automatiza chats de Messenger o responde manualmente usando la app de Messenger.",
  "auth.title": "Tu agente de soporte con IA 24/7",
  "auth.description":
    "Resuelve al instante las preguntas de tus clientes en tu sitio web, WhatsApp y Instagram con poderosos agentes de IA que puedes entrenar en minutos. Sin necesidad de código.",
  "auth.description.mobile":
    "Responde al instante a tus clientes en web y WhatsApp. Sin código. Listo en minutos.",
  "auth.login.title": "Iniciar sesión",
  "auth.login.email": "Correo electrónico",
  "auth.login.password": "Contraseña",
  "auth.login.login": "Iniciar sesión",
  "auth.login.registerLabel": "¿Nuevo en Visito?",
  "auth.login.register": "Crear una cuenta",
  "auth.login.getAdemo": "Solicitar una demo",
  "auth.login.forgotPassword": "Click aquí",
  "auth.login.forgotLabel": "¿Olvidó su contraseña?",
  "auth.login.google": "Iniciar sesión con Google",
  "auth.login.microsoft": "Iniciar sesión con Microsoft",
  "auth.login.error": "Correo electrónico o contraseña no válidos",
  "auth.register.google": "Registrarse con Google",
  "auth.register.microsoft": "Registrarse con Microsoft",
  "auth.register.title": "Comienza gratis",
  "auth.register.company": "Nombre de la empresa",
  "auth.register.web": "Sitio web",
  "auth.register.email": "Correo electrónico",
  "auth.register.password": "Contraseña",
  "auth.register.register": "Registrarse",
  "auth.register.loginLabel": "¿Ya tienes una cuenta?",
  "auth.register.login": "Iniciar sesión",
  "auth.register.loginTerms": "Términos de Servicio",
  "auth.register.loginPrivacy": "Política de Privacidad",
  "auth.register.continuing": "Al continuar, aceptas nuestros",
  "auth.register.titleCloudbeds": "Crea tu cuenta de Visito",
  "auth.registerUser.title": "Acepta tu invitación",
  "auth.registerUser.subtitle":
    "Estás aceptando una invitación para unirte a Visito. Crea tu cuenta para continuar.",
  "auth.registerUser.googleOption":
    "Crea tu cuenta con Google (el mismo correo de la invitación).",
  "auth.registerUser.passwordOption": "O crea tu cuenta con una contraseña.",
  "auth.registerUser.nextStepsTitle": "Qué hacer ahora",
  "auth.registerUser.stepOne":
    "Elige cómo quieres continuar: con Google o con contraseña.",
  "auth.registerUser.stepTwo":
    "Si continúas con contraseña, créala y haz clic en Registrarse.",
  "auth.registerUser.stepThree":
    "Si Google abre la cuenta incorrecta, cierra sesión y elige el correo invitado.",
  "auth.registerUser.error":
    "El correo electrónico con el que estás intentando registrarte no coincide con el de tu invitación",

  "auth.forgotPassword.title": "Restablecer contraseña",
  "auth.forgotPassword.email": "Email",
  "auth.forgotPassword.submit": "Enviar",
  "auth.forgotPassword.success":
    "El enlace para restablecer tu contraseña se ha enviado a su email",
  "auth.forgotPassword.error":
    "Email no encontrado. Por favor, verifica e intenta de nuevo.",
  "auth.forgotPassword.description":
    "Ingresa la dirección de correo electrónico asociada a tu cuenta y te enviaremos un enlace para restablecer tu contraseña",
  "auth.resetPassword.title": "Restablecer tu contraseña",
  "auth.resetPassword.password": "Nueva contraseña",
  "auth.resetPassword.cancel": "Cancelar",
  "auth.resetPassword.submit": "Restablecer",
  "auth.resetPassword.success":
    "Tu contraseña ha sido restablecida con éxito. Ahora puedes iniciar sesión en tu cuenta usando tu nueva contraseña.",
  "auth.resetPassword.description": "Elige una nueva contraseña abajo.",
  "auth.userInvite.success": "Invitación aceptada correctamente",
  "contactDetail.header": "Información",
  "contactDetail.title": "Perfil de contacto",
  "contactDetail.leadInfo": "Información del lead",
  "contactDetail.actions": "Actividad del chat",
  "contactDetail.bookings": "Reservas",
  "contactDetail.followers": "seguidores",
  "contactDetail.toolCalls": "Actividad",
  "leads.datePlaceholder": "Fecha",
  "contactDetail.assignUser": "Assignar usuario a este chat",
  "contactDetail.unassignUser": "Desasignar",
  "contactDetail.assignation": "Asignación del chat",
  "contactDetail.loadingChat": "Cargando mensajes ...",
  "toolCalls.book": "Reserva ofrecida",
  "toolCalls.availability": "Reserva ofrecida",
  "toolCalls.pricing": "Liga de pago generada",
  "toolCalls.payment_received": "Reserva generada",
  "toolCalls.help": "Solicito Ayuda",
  "toolCalls.manual": "Revisión Manual",
  "toolCalls.follow_up_after_inactivity": "Seguimiento Inteligente",
  "chats.newMessageInput": "Ingrese el mensaje...",
  "chats.searchContact": "Buscar contacto",
  "chats.fileCaptionPlaceholder": "Agrega una descripción...",
  "chats.filters": "Filtros",
  "chats.aiAuto":
    "Controla respuestas automáticas de IA. Si esta desactivado, la IA no responderá automáticamente a los mensajes entrantes.",
  "chats.markAsOpen": "Marcar como revisión",
  "chats.markAsClose": "Marcar como resuelto",
  "chats.archive": "Archivar chat",
  "chats.unArchive": "Desarchivar chat",
  "chats.archived": "Archivados",
  "chats.all": "Todos",
  "chats.accounts": "Cuentas",
  "chats.enabled": "Manual",
  "chats.enabled.explanation":
    "Chats que tienen respuestas generadas por IA desactivadas.",
  "chats.followUp": "Seguimiento inteligente",
  "chats.blocked": "Bloqueado",
  "chats.reply": "Responder",
  "chats.clone": "Clonar en playground",
  "chats.flag": "Reportar",
  "chats.assignation": "Asignación",
  "chats.userMessage": "Mensaje del usuario",
  "chats.assistantResponse": "Respuesta del bot",
  "chats.expectedResponse": "Respuesta esperada",
  "chats.updateAnswer": "Reportar respuesta",
  "chats.expectedResponsePlaceholder": "Escribe aquí la respuesta ideal...",

  "chats.isGuest": "Huésped",
  "chats.isBook": "Reserva Ofrecida",
  "chats.book": "Reserva Ofrecida",
  "chats.isManual": "Conversación Manual",
  "chats.isManual.explanation": "Chats que tienen alguna respuesta manual",
  "chats.ai.isManual": "Conversación Manual",
  "chats.help": "Solicito ayuda",
  "chats.isConversion": "Conversión",
  "chats.outbound_conversion": "Outbound Conversion",
  "chats.payment_received": "AI Booking",
  "chats.isPayment": "Liga de pago generada",
  "chats.isBooked": "Reserva generada",
  "chats.unblockContact": "Desbloquear Contacto",
  "chats.blockContact": "Bloquear Contacto",
  "chats.contactOptedOut": "El contacto se ha dado de baja",
  "chats.filter": "Filtrar",
  "chats.escalated": "Revisión",
  "chats.escalated.explanation":
    "Chats que la IA ha escalado y necesitan revisión",
  "chats.bucket.all": "Todos",
  "chats.bucket.mine": "Míos",
  "chats.bucket.mine.explanation":
    "Chats que has respondido o que están asignados a ti",
  "chats.ad": "Anuncios",
  "chats.bucket.pending": "Requiere revisión",
  "chats.bucket.pending.explanation":
    "Chats que la IA ha escalado y necesitan revisión",
  "chats.emptyStateTitle": "Aún no hay conversaciones",
  "chats.emptyStateSubtitle": "Tu lista de chat espera tu primer mensaje",
  "chats.emptyStateEscTitle": "No se encontraron conversaciones",
  "chats.emptyStateEscSubtitle":
    "Borra tus filtros o busca una conversación específica",

  "chats.emptyStatePendingTitle":
    "No hay conversaciones que requieran tu acción",
  "chats.emptyStatePendingSubtitle":
    "¡Buen trabajo! No hay conversaciones que requieran tu acción en este momento.",
  "chats.emptyWelcomeTitle": "No hay conversación seleccionada",
  "chats.emptyWelcomeSubtitle":
    "Elige una conversación de la izquierda para ver sus mensajes.",

  "chats.searchNoResults": "No se encontraron resultados",
  "chats.searchStart": "Empieza a escribir para buscar",

  "interactive.call.summary": "Resumen de la llamada",
  "interactive.call.active": "Llamada activa",
  "integrations.title": "Integraciones",

  "integrations.alert.title": "No disponible en tu plan",
  "integrations.alert.description":
    "Tu plan actual no permite usar este canal o integración. Para activarlo, actualiza tu plan.",
  "integrations.alert.billing": "Actualiza tu plan",
  "integrations.alert.dismiss": "Entendido",
  "integrations.degradedStatus": "Error detectado",
  "integrations.alert.wa.title": "Conectar WhatsApp puede ser complicado",
  "integrations.alert.wa.description":
    "Meta aplica reglas estrictas al conectar un número de WhatsApp. Entre los problemas más comunes están el rechazo del número, la necesidad de eliminarlo de la app y bloqueos inesperados. Te recomendamos leer nuestra guía paso a paso o agendar una llamada con nuestro equipo. También puedes continuar por tu cuenta si lo prefieres.",
  "integrations.alert.wa.guide": "Leer la guía",
  "integrations.alert.wa.button": "Agendar llamada de onboarding",
  "integrations.alert.wa.continue": "Continuar de todos modos",

  "integrations.propertiesListTitle": "Propiedades",
  "integrations.noProperties": "No se encontraron propiedades",
  "integrations.embedChat": "Inserta una burbuja de chat en tu página web",
  "integrations.embedChatDescription":
    "Copia el código de abajo y pégalo en el código fuente de tu página web",
  "integrations.webChatLaunchTarget": "Acción de la burbuja",
  "integrations.webChatLaunchTargetDescription":
    "Elige si la burbuja abre el web chat o redirige a WhatsApp.",
  "integrations.webChatLaunchWebchat": "Website chat",
  "integrations.webChatLaunchWhatsappPrefix": "WhatsApp",
  "integrations.webChatBubbleColor": "Color de la burbuja",
  "integrations.webChatBubbleColorDescription":
    "Este color se aplica a la burbuja del chat embebido en todos los sitios que usan esta API key.",
  "integrations.webChatWidgetDesktopSize": "Tamaño del widget (escritorio)",
  "integrations.webChatWidgetMobileSize": "Tamaño del widget (móvil)",
  "integrations.webChatWidgetWidthPx": "Ancho (px)",
  "integrations.webChatWidgetHeightPx": "Alto (px)",
  "integrations.webChatWidgetWidthVw": "Ancho (vw)",
  "integrations.webChatWidgetHeightVh": "Alto (vh)",
  "integrations.webChatWidgetSizeDescription":
    "Escritorio acepta ancho 280-1000px y alto 400-1400px. Móvil acepta ancho 50-100vw y alto 50-100vh.",

  "integrations.waSettings": "Configuración de WhatsApp",
  "integrations.waPaymentMethod": "Configura tu Pago",

  "integrations.deleteTitle":
    "¿Estás seguro de que quieres eliminar esta integración?",
  "integrations.deleteDesc":
    "Esta acción no se puede deshacer. La integración dejará de funcionar de inmediato y deberás volver a conectarla si deseas usarla otra vez.",

  "integrations.wordpress": "Plugin de WordPress",
  "integrations.wordpressInstructions":
    "Para usar Visito AI en WordPress, sigue estos pasos:",
  "integrations.wordpressStep1": "Instala el plugin de Visito:",
  "integrations.wordpressStep2":
    "Activa el plugin y pega tu clave API en tu panel de WordPress en Ajustes > Visito AI.",

  "integrations.webChat": "Comparte tu asistente virtual",
  "integrations.webName": "Web Chat",
  "integrations.playName": "Playground Chat",
  "integrations.webChatDescription":
    "Copia la liga de abajo para compartir con otros tu asistente virtual",
  "integrations.copyLink": "Copiar",
  "integrations.visitLink": "Abrir",
  "integrations.acceptNewIntegration":
    "Por favor, acepte la nueva integración entrante de {provider}",
  "integrations.completedNewIntegration":
    "Has aceptado con éxito la integración con {provider}",

  "integrations.completedDbIntegration": "Integración añadida con éxito",

  "integrations.webChatName": "Sitio Web",
  "integrations.fmName": "Messenger",
  "integrations.waName": "WhatsApp",
  "integrations.cbName": "Cloudbeds",
  "integrations.haName": "Hostaway",
  "integrations.igName": "Instagram",
  "integrations.smName": "SiteMinder",
  "integrations.gsName": "Guesty",
  "integrations.miraiName": "Mirai",
  "integrations.mwName": "Mews",
  "integrations.voiceName": "Voz",
  "integrations.shopName": "Shopify",
  "integrations.wpName": "WooCommerce",
  "integrations.wxName": "Wix Hotels",
  "integrations.hrName": "HotelRunner",

  "integrations.manualReplies": "La automatización por IA está en pausa",
  "integrations.autoReplies": "La automatización por IA está activa",

  "integrations.pmsActive": "El acceso está activo.",
  "integrations.pmsPaused": "El acceso está en pausa.",

  "integrations.igReconnect": "Agrega o quita cuentas",
  "integrations.waReconnect": "Agrega o quita numeros",
  "integrations.fmReconnect": "Agrega o quita páginas",
  "integrations.voiceReconnect": "Agrega or quita números",
  "integrations.wpReconnect": "Agrega nuevas propiedades",
  "integrations.shopReconnect": "Agrega nuevas propiedades",

  "integrations.cbReconnect": "Agrega nuevas propiedades",
  "integrations.smReconnect": "Agrega nuevas propiedades",
  "integrations.gsReconnect": "Agrega nuevas propiedades",
  "integrations.haReconnect": "Agrega nuevas propiedades",
  "integrations.mwReconnect": "Agrega nuevas propiedades",
  "integrations.wxReconnect": "Agrega nuevas propiedades",
  "integrations.hrReconnect": "Agrega nuevas propiedades",

  "integrations.guide": "Guía de integración",
  "integrations.missingInformation":
    "A tu integración le falta información necesaria. Revisa la guía de integración y haz clic en ‘Gestionar’ para completar la configuración de tu cuenta.",

  "integrations.smAdd": "Agrega una nueva propiedad de SiteMinder",
  "integrations.gsAdd": "Agrega una nueva propiedad de Guesty",
  "integrations.mwAdd": "Agrega una nueva propiedad de Mews",
  "integrations.wpAdd": "Agrega tu tienda de WooCommerce",
  "integrations.shopAdd": "Agrega tu tienda de Shopify",
  "integrations.wxAdd": "Agrega una nueva propiedad de Wix Hotels",
  "integrations.hrAdd": "Agrega una nueva propiedad de HotelRunner",

  "integrations.nameDb": "Nombre",
  "integrations.refreshTokenDb": "API Secret",
  "integrations.tokenDb": "Token de acceso",
  "integrations.websiteDb": "Sitio web",
  "integrations.clientIdDb": "API Client ID",
  "integrations.integrationTokenDb": "Token de integracion",
  "integrations.propertyIdDb": "ID de la Propiedad",
  "integrations.widgetIdDb": "Widget del motor de reservas",
  "integrations.publisherDb": "Publicador",
  "integrations.currencyDb": "Moneda",
  "integrations.countryCodeDb": "Selecciona el país",
  "integrations.timezoneDb": "Zona Horaria",
  "integrations.xXsrfTokenDb": "X-Xsrf-Token",
  "integrations.xWixInstanceDb": "X-Wix-Instance",
  "integrations.wixBookingBaseUrlDb": "URL base de reservas Wix",
  "integrations.hotelrunnerApiKeyDb": "API key de HotelRunner",
  "integrations.hotelrunnerOTokenDb": "o_token de HotelRunner",
  "integrations.hotelrunnerONumberDb": "o_number de HotelRunner",
  "integrations.hotelrunnerChallengeDb": "X-HR-Challenge",
  "integrations.hotelrunnerBaseUrlDb": "URL base de HotelRunner",
  "integrations.bookingEngineDb": "Motor de Reservas",
  "integrations.phoneNumberDb": "Número de teléfono",

  "integrations.integrationTokenDbPlaceholder":
    "Pega tu token de integracion de Guesty (de un solo uso, expira en 4 horas)",
  "integrations.refreshTokenDbPlaceholder":
    "Your API secret from guesty API dashboard",
  "integrations.clientIdDbPlaceholder":
    "Your Client ID from guesty API dashboard",
  "integrations.nameDbPlaceholder": "Hotel Santa Fe",
  "integrations.propertyIdDbPlaceholder": "28093",
  "integrations.widgetIdDbPlaceholder": "santafedirect",
  "integrations.publisherDbPlaceholder": "littlehotelier",
  "integrations.currencyDbPlaceholder": "MXN",
  "integrations.countryCodeDbPlaceholder": "CO",
  "integrations.phoneNumberDbPlaceholder": "5585655477",
  "integrations.tokenDbPlaceholder": "shpat_*****************************",
  "integrations.websiteDbPlaceholder": "https://mystore.com",
  "integrations.xXsrfTokenDbPlaceholder": "1775664531|KKHB0gLdhXRI",
  "integrations.xWixInstanceDbPlaceholder": "eyJpbnN0YW5jZUlkIjoi...",
  "integrations.wixBookingBaseUrlDbPlaceholder": "https://www.myhotel.com/rooms",
  "integrations.hotelrunnerApiKeyDbPlaceholder":
    "7518391247a27ce412d421ffe241c6ffd3f52e7c4b26e993",
  "integrations.hotelrunnerOTokenDbPlaceholder":
    "a8c4516976fe2feffcbe173925822c7c",
  "integrations.hotelrunnerONumberDbPlaceholder": "R076950164",
  "integrations.hotelrunnerChallengeDbPlaceholder": "609402",
  "integrations.hotelrunnerBaseUrlDbPlaceholder":
    "https://tu-propiedad.hotelrunner.com",

  "integrations.pageTitle": "Integraciones",
  "integrations.pageConnectTitle": "Canales",
  "integrations.pageDescription":
    "Conecta tu asistente a los principales canales de comunicación y fuentes de datos",

  "integrations.fmDescription": "Conecta tus páginas de Facebook",
  "integrations.waDescription": "Conecta tu número de WhatsApp",
  "integrations.cbDescription": "Conecta tus propiedades de Cloudbeds",
  "integrations.haDescription": "Conecta tus propiedades de Hostaway",
  "integrations.igDescription": "Conecta tus cuentas de Instagram",
  "integrations.smDescription": "Conecta tus propiedades de SiteMinder",
  "integrations.gsDescription": "Conecta tus propiedades de Guesty",
  "integrations.miraiDescription": "Conecta tu motor de reservas de Mirai",
  "integrations.mwDescription": "Conecta tus propiedades de Mews",
  "integrations.voiceDescription": "Conecta tu número de teléfono",
  "integrations.wxDescription": "Conecta tus propiedades de Wix Hotels",
  "integrations.hrDescription": "Conecta tus propiedades de HotelRunner",
  "integrations.shopDescription": "Conecta tu tienda de Shopify",
  "integrations.wpDescription": "Conecta tu tienda de WooCommerce",

  "teams.title": "Gestión de Equipos",
  "teams.subTitle": "Gestiona el acceso de los miembros del equipo",
  "teams.inviteMember": "Invitar a un nuevo miembro del equipo",
  "teams.selectorLabel": "Rol",
  "teams.rol.admin": "Administrador",
  "teams.rol.user": "Usuario",
  "teams.emailLabel": "Email",
  "teams.button": "Invitar",
  "teams.message.success":
    "Un enlace de invitación ha sido enviado a su correo.",
  "teams.passwordLabel": "Contraseña",
  "teams.buttonAccept": "Aceptar",
  "teams.inviteInfo": "Aceptar invitación a Equipos",
  "teams.modalMessageTitle.success": "Invitación exitosa",
  "teams.modalMessageTitle.error": "Error al enviar invitación",
  "teams.modal.button": "Cerrar",
  "invitedList.Members": "Lista de miembros del equipo",
  "invitedList.Invites":
    "{count, plural, one {# invitacion restante} other {# invitaciones restantes}}",
  "invitedList.emailLabel": "Email",
  "invitedList.roleLabel": "Rol",
  "invitedList.dateLabel": "Se unió",
  "invitedList.title.deleteSuccess": "Eliminar usuario",
  "invitedList.message.deleteSuccess": "Usuario eliminado correctamente",
  "invitedList.message.deleteError": "Error al eliminar el usuario",
  "payment.title": "Facturación",
  "payment.subTitle":
    "Administra tus métodos de pago, suscripciones y detalles de facturación.",
  "payment.noPlanAlert":
    "No estás suscrito a ningún plan. Suscríbete a un plan para aumentar tus créditos de mensajes.",
  "payment.monthly": "Mensual",
  "payment.annual": "Anual",
  "payment.billingCycle": "Ciclo de facturación",
  "payment.currentPlan": "Plan actual",
  "payment.managePlan": "Administrar pago",
  "payment.changePlan": "Cambiar a este plan",
  "payment.changePlanPayNow": "Cambiar a este plan y pagar ahora",
  "payment.manageCurrentPlan":
    "Administra tu plan - cambia o mejora para aumentar tus créditos de mensajes",
  "payment.billingEmail": "Email de Facturación",
  "payment.subscribe": "Subscribite a este plan",
  "payment.selectAPlan": "Seleccionar Plan",
  "payment.planTier":
    "{credits, number} créditos de mensajes - {price, number, ::currency/USD}/mes",
  "payment.planTierMonthly":
    "{credits, number} créditos de mensajes - {price, number, ::currency/USD}/mes",
  "payment.planTierAnnual":
    "{credits, number} créditos de mensajes - {price, number, ::currency/USD}/año",
  "payment.downgradeScheduled": "Cambio a plan inferior programado para {date}",
  "payment.pendingDowngrade": "Cambio pendiente a plan inferior el {date}",
  "payment.currentPlanUntil": "Plan actual: {plan} hasta {date}",
  "payment.scheduledPlanFrom": "Plan programado: {plan} desde {date}",
  "payment.scheduledPlan": "Plan programado (inicia {date})",
  "payment.planNoop": "Ya estás en este plan",
  "payment.planNoopCurrent": "Ya estás en este plan actual",
  "payment.planNoopScheduled":
    "Este cambio ya está programado para {date}",
  "payment.portalError":
    "No se pudo abrir el portal de pagos, intenta nuevamente más tarde",
  "usage.title": "Uso",
  "usage.customRangeTitle": "Rango de fechas personalizado",
  "usage.subTitle":
    "Monitorea el consumo diario de créditos facturables en tu ciclo actual",
  "usage.filterBillingCycle": "Ciclo de facturación actual",
  "usage.kpiTotal": "Créditos facturables totales",
  "usage.kpiAverage": "Promedio por día",
  "usage.kpiPeak": "Pico diario",
  "usage.empty":
    "Todavía no hay actividad de créditos facturables en este período. Vuelve a revisar más tarde.",
  "usage.error":
    "No se pudieron cargar los datos de uso en este momento. Inténtalo de nuevo en un instante.",
  "usage.axisCredits": "Créditos",
  "usage.creditsUsed": "créditos usados",
  "usage.seriesBillable": "Créditos facturables",
  "language.title": "Idioma",
  "language.subTitle":
    "Seleccione el idioma al que desea cambiar la plataforma",
  "language.selectorLabel": "Seleccionar Idioma",
  "language.english": "English",
  "language.spanish": "Español",
  "language.portuguese": "Português",
  "language.languages": "Idiomas",
  "language.en_US": "Inglés",
  "language.es_MX": "Español",
  "language.pt_BR": "Portugués",

  "home.statsTitle": "Estadísticas de los últimos 30 días",
  "home.planTitle": "Estadísticas del plan actual",
  "home.pageTitle": "Hola",
  "home.pageDescription": "Bienvenido a tu dashboard de Visito",

  "home.skip": "Saltar introducción",

  "home.onboardingTitle": "Empezar",
  "home.onboardingDescription":
    "Completa los siguientes pasos para configurar tu cuenta",

  "home.title_location": "Conecta una propiedad",
  "home.description_location": "Integra tu propiedad con Visito",

  "home.title_channel": "Conecta un canal",
  "home.description_channel":
    "Conecta un canal para empezar a recibir mensajes",

  "home.title_account": "Crea tu cuenta",
  "home.description_account":
    "Administra todas las comunicaciones en una sola bandeja de entrada de Visito",
  "home.title_wa": "Conectar WhatsApp",
  "home.description_wa":
    "Alcanza a más de 2 mil millones de clientes en todo el mundo",

  "home.title_fm": "Conectar Facebook Messenger",
  "home.description_fm":
    "Impulsa el soporte y las reservas con Facebook Messenger",

  "home.title_ig": "Conectar Instagram",
  "home.description_ig":
    "Conecta la bandeja de entrada de tu cuenta de Instagram para empezar a recibir mensajes",

  "home.title_ai": "Configura las fuentes de entrenamiento de la IA",
  "home.description_ai": "Programa tu agente de IA con la información correcta",

  "home.messageLimit": "Créditos de mensajes restantes",
  "home.messageResetDate": "Fecha reinicio",
  "home.quotaLeft": "Créditos: {remaining} / {total} ({pct}%)",
  "home.trialBadge": "Prueba · {days}d restantes",
  "home.trialEndsOn": "La prueba termina el {date}",
  "home.trialNoticeTitle": "Prueba gratis activa",
  "home.trialNoticeBody":
    "Tu tarjeta se cobrará el {date} a menos que canceles antes.",
  "home.trialNoticeCta": "Gestionar facturación",
  "home.descriptionLimit":
    "{count, plural, one {# mensaje disponible} other {# mensajes disponibles}} de {messageLimit, number}",

  "home.remainingQuotaOutOf": "{remaining} restantes de {limit}",

  "home.dateLimit": "Se restablece el {date}",
  "home.increaseLimit": "Ampliar plan",
  "home.limitReached": "Límite alcanzado",
  "home.nearLimit": "Cerca del límite",
  "home.plentyLeft": "Queda mucho por usar",
  "home.messagesUnderReview": "Mensajes en revisión",
  "home.unreadManualMessages": "Mensajes manuales sin leer",
  "home.links": "Accesos rápidos",
  "home.planUsageHelper": "Restante",
  "home.requiresAction": "Mensajes que requieren tu acción",

  "home.pendingItems": "acciones pendientes",

  "home.uniqueContacts": "Contactos Únicos",
  "home.totalMessages": "Mensajes Totales",
  "home.percentageAuto": "Resolución IA (%)",
  "home.noStats":
    "Parece que aún no hay datos. Por favor, vuelva más tarde o ajuste sus filtros.",
  "home.maintenance": "Volvemos en breve 🛠️",
  "home.maintenance.desc":
    "Estamos realizando algunas mejoras para ofrecerte un mejor servicio.Toda tu información está segura y pronto estaremos de vuelta",
  "home.updateApp": "Actualización requerida",
  "home.updateApp.desc":
    "Hay una nueva versión ({remoteVersion}) disponible. Por favor, actualiza la aplicación para continuar.",
  "home.updateApp.btn": "Actualizar ahora",

  "api.title": "Claves API",
  "api.subTitle": "Administra tus claves API",
  "api.description":
    "Consulta nuestra documentación completa sobre cómo usar la API.",
  "api.regenerate.warningTitle":
    "¿Estás seguro de que deseas regenerar esta clave API?",
  "api.regenerate.warningDesc":
    "Regenerar la clave API invalidará la actual y deberás actualizar tus aplicaciones en consecuencia.",
  "leads.intent": "Resúmen",
  "leads.score": "Calidad",
  "leads.high": "Alta",
  "leads.medium": "Media",
  "leads.low": "Baja",
  "leads.no_score": "-",
  "leads.filter.actions": "Actividad del chat",
  "leads.filter.company": "Filtrar por cuenta",
  "leads.stats.book": "Disponibilidad",
  "leads.stats.pricing": "Genero liga de pago",
  "leads.stats.opt_in": "Opted in",
  "leads.stats.payment_received": "Ha reservado",
  "leads.stats.payment_receivedExplanation":
    "Reserva completada en la conversación.",
  "leads.stats.total": "Todos",
  "leads.stats.paid": "Pagados",
  "leads.followUp": "Seguimientos",
  "leads.stats.availability": "Disponibilidad",
  "leads.stats.availabilityExplanation":
    "Disponibilidad solicitada en el chat.",
  "leads.stats.help": "Solicito ayuda",
  "leads.stats.arrival_time": "Tiempo llegada",
  "leads.stats.confirm": "Confirmadas",
  "leads.stats.postConfirm": "Confirmadas",
  "leads.stats.reservation_details": "Pregunto detalles",
  "leads.stats.rating": "Ha calificado",
  "leads.stats.generate_payment_link": "Genero liga de pago",
  "leads.stats.postConfirmError": "Algo salio mal",
  "leads.pageTitle": "Leads",
  "leads.pageDescription":
    "Clientes potenciales que han iniciado una conversación",
  "leads.isBook": "Disponibilidad solicitada",
  "leads.isPayment": "Liga de pago generada",
  "leads.isBooked": "Reserva completada",
  "leads.escalated": "Marcado para revision",
  "leads.isManual": "Respondido manualmente",
  "leads.help": "Solicito ayuda",
  "leads.export": "Exportar",
  "leads.followUpStatus.no_follow_up": "-",
  "leads.followUpStatus.pending": "En evaluación",
  "leads.followUpStatus.followed_up": "Enviado",
  "leads.followUpStatus.rejected": "No recomendado",
  "leads.followUpStatus.howManySent": "{count} enviados",
  "leads.noScoreExplanation": "Aún no hay puntuación",
  "leads.noIntent": "-",
  "leads.noLeads": "No se encontraron leads",

  "leads.followUpStatus.no_follow_upExplanation": "No hay seguimientos.",
  "leads.followUpStatus.pendingExplanation":
    "La IA está evaluando si es necesario hacer un seguimiento según la última interacción del usuario. {count, plural, =0 {} other {Se enviaron anteriormente {count} seguimiento(s).}}",
  "leads.followUpStatus.followed_upExplanation":
    "La IA ha enviado un mensaje de seguimiento para retomar el contacto. {count, plural, one {Se ha enviado un seguimiento.} other {Se han enviado {count} seguimientos.}}",
  "leads.followUpStatus.rejectedExplanation":
    "La IA determinó que no era necesario hacer un seguimiento. {count, plural, =0 {} one {Se había enviado un seguimiento anteriormente.} other {Se habían enviado {count} seguimientos anteriormente.}}",

  "leads.noIntentExplanation":
    "La IA aún no ha identificado la intención del usuario en esta conversación. Se actualizará una vez que la conversación sea analizada.",
  "leads.date": "Último mensaje",
  "leads.payments.pageTitle": "Pagos",
  "leads.payments.date": "Fecha",
  "leads.payments.paymentBreakDown": "Desglose de Pagos",
  "leads.payments.bookings": "Reservas",
  "leads.payments.reference": "Referencia",
  "leads.payments.status": "Estado",
  "leads.payments.amount": "Monto",
  "leads.payments.makeArefund": "Reembolsar",
  "leads.payments.paymentRequested": "Pago solicitado",
  "leads.payments.fees": "Comisiones de Stripe",
  "leads.payments.commission": "Comisión de Visito",
  "leads.payments.netAmount": "Subtotal",
  "leads.payments.providerNetAmount": "Total",
  "leads.payments.transferStatus": "Estado de Transferencia",
  "leads.payments.pending": "Pendiente",
  "leads.payments.transfered": "Transferido",
  "leads.payments.refunded": "Reembolsado",
  "leads.payments.pendingTransfer": "Transferencia pendiente",
  "leads.payments.expired": "Expirado",
  "leads.payments.active": "No pagado",
  "leads.payments.paid": "Pagado",
  "leads.payments.refunds": "Reembolsos",
  "leads.payments.reconciled": "Conciliado",
  "leads.payments.transferFunds": "Ejecutar transferencia",
  "leads.payments.hydrateBalance": "Ejecutar hidratación de balance",
  "leads.payments.viewConversation": "Ver Conversación",
  "leads.payments.refundPayment": "Reembolsar pago",
  "leads.payments.refundAmount": "Monto a reembolsar",
  "payments.stripe.title": "Pagos con Stripe Express",
  "payments.stripe.connectMessage":
    "Conecta tu cuenta bancaria para comenzar a recibir pagos en chat de tus huéspedes.",
  "payments.stripe.landingHeadline":
    "Empieza a recibir pagos en chat para tu negocio",
  "payments.stripe.landingSubheadline":
    "Conecta tu cuenta bancaria para cobrar en chat productos, servicios o reservas desde un solo lugar.",
  "payments.stripe.docsInChatPayments": "Docs de pagos en chat",
  "payments.stripe.docsItemsCatalog": "Docs de catálogo de ítems",
  "payments.stripe.connect": "Conectar cuenta bancaria",
  "payments.stripe.connectedAccount": "Cuenta conectada: {account}",
  "payments.stripe.itemsToggleLabel": "Activar cobro de ítems en chat",
  "payments.stripe.itemsToggleHelp":
    "Permite que la IA genere links de pago para ítems de tu catálogo.",
  "payments.stripe.payoutsToggle":
    "Activar cobro de pagos en chat (en lugar de redirigir al motor de reservas)",
  "payments.stripe.depositPercentageLabel": "Depósito a cobrar en el chat",
  "payments.stripe.depositPercentageHelp":
    "Elige entre 1% y 100% del total de la reserva.",
  "payments.stripe.openExpress": "Abrir Stripe Express",
  "payments.stripe.disconnect": "Desconectar",
  "payments.stripe.disconnectSuccess": "Cuenta de Stripe desconectada",
  "payments.items.title": "Catálogo de ítems",
  "payments.items.subtitle":
    "Crea productos o servicios que la IA pueda cobrar directamente en el chat.",
  "payments.items.name": "Nombre",
  "payments.items.namePlaceholder": "Ej: Pasadía",
  "payments.items.description": "Descripción",
  "payments.items.descriptionPlaceholder":
    "Ej: Acceso de día completo a piscina e instalaciones",
  "payments.items.price": "Precio",
  "payments.items.pricePlaceholder": "Ej: 20.00",
  "payments.items.currency": "Moneda",
  "payments.items.active": "Ítem activo",
  "payments.items.propertiesTitle": "Detalles del ítem",
  "payments.items.propertiesSubtitle":
    "Captura detalles de cada venta (fecha, opción, notas, etc.).",
  "payments.items.addProperty": "Agregar detalle",
  "payments.items.propertiesEmpty": "No hay detalles configurados.",
  "payments.items.propertyLabel": "Nombre del detalle",
  "payments.items.propertyLabelPlaceholder": "Ej: Día",
  "payments.items.propertyType": "Tipo de detalle",
  "payments.items.propertyRequired": "Detalle obligatorio",
  "payments.items.propertyType.date": "Fecha",
  "payments.items.propertyType.enum": "Lista",
  "payments.items.propertyType.text": "Texto",
  "payments.items.propertyType.number": "Número",
  "payments.items.propertyEnumOptions": "Opciones de lista",
  "payments.items.propertyEnumOptionPlaceholder": "Ej: Tejido profundo",
  "payments.items.propertyAddOption": "Agregar opción",
  "payments.items.propertiesCount":
    "{count, plural, one {# detalle} other {# detalles}}",
  "payments.items.docs": "Docs",
  "payments.items.create": "Crear ítem",
  "payments.items.update": "Actualizar ítem",
  "payments.items.cancelEdit": "Cancelar edición",
  "payments.items.empty": "Todavía no hay ítems creados.",
  "payments.items.statusActive": "Activo",
  "payments.items.statusInactive": "Inactivo",
  "payments.items.edit": "Editar",
  "payments.items.deactivate": "Desactivar",
  "payments.items.delete": "Eliminar",
  "payments.items.deleteConfirm": "¿Eliminar este ítem?",
  "payments.items.validationError":
    "Completa nombre, precio, moneda y detalles válidos antes de guardar.",
  "payments.tabs.stripeAccount": "Cuenta Stripe",
  "payments.tabs.bookingSettings": "Ajustes de reservas",
  "payments.tabs.itemSettings": "Ajustes de ítems",
  "payments.booking.connectStripeFirst":
    "Conecta primero tu cuenta de Stripe para configurar los ajustes de reservas.",
  "leads.payments.itemProperties": "Detalles del ítem",
  "outbound.event": "Evento",
  "outbound.pageTitle": "Eventos",
  "outbound.pageDescription":
    "Mejora la experiencia del huésped con mensajes automatizados durante todo el proceso de reserva",
  "outbound.viewEvent": "Ver evento",
  "outboud.messagesSent": "Mensajes enviados en los últimos 30 días",
  "outbound.reservation":
    "Después de que un huésped complete su reserva, el huésped recibe un mensaje de confirmación con detalles de su reserva.",
  "outbound.time_reservation": "Enviado inmediatamente",
  "outbound.arrival":
    "Antes de la llegada, el huésped recibe un mensaje con información útil sobre su estancia.",
  "outbound.time_arrival": "2 días antes de la llegada",
  "outbound.stay":
    "Después de que el huésped haga el check-in, el huésped recibe un mensaje con instrucciones especiales e información útil.",
  "outbound.time_stay": "Enviado inmediatamente después de la llegada",
  "outbound.after_departure":
    "Después de que el huésped haga el check-out, el huésped recibe un mensaje de agradecimiento junto con una solicitud de retroalimentación.",
  "outbound.time_after_departure":
    "Enviado inmediatamente cuando el huésped hace el check-out",
  "outbound.inactiveTitle":
    "¿Estás seguro de que deseas desactivar este evento?",
  "outbound.inactiveDesc":
    "Desactivar este evento provocará que no se envíen estos mensajes.",
  "outbound.disabling": "Desactivando el evento...",
  "outbound.cardTitle": "Eventos de Salida",
  "outbound.recentActivity": "Actividad Reciente",
  "outbound.noActivity": "Sin actividad",
  "outbound.missingChannel":
    "¡Ups! Aún no has conectado un número de WhatsApp a tu cuenta.",
  "outbound.missingChannelDesc":
    "Conecta tu número de WhatsApp para interactuar con tus huéspedes durante las reservas, las llegadas y después de su partida.",
  "outbound.missingChannelCTA": "Haga clic aquí para conectar",
  "outbound.modifyTemplate": "Editar plantilla",
  "outbound.templateTitle": "Editar {template}",
  "outbound.templateLastUpdate":
    "Última modificación: {date} (Modificado {count, plural, one {# vez} other {# veces}} en 30 días)",
  "outbound.templateLangDesc":
    "Modifique el mensaje que desea enviar a los huéspedes en {lang}",
  "outbound.templatePreview": "Vista previa del mensaje",
  "outbound.templatePreviewDesc":
    "A continuación se muestra cómo se verá su mensaje",
  "outbound.templateVarsInfo":
    "Es posible que deba asegurarse que las etiquetas se ingresen correctamente. A continuación se listan para saber qué etiquetas puede usar",
  "outbound.templateVardDesc":
    "Utilice estas etiquetas en el cuerpo del mensaje",
  "outbound.templateTag": "Etiqueta",
  "outbound.templateFunction": "Función",
  "outbound.template_confirmationId": "Número de confirmación",
  "outbound.template_username": "El nombre completo del contacto",
  "outbound.template_checkin": "Fecha de entrada del huésped",
  "outbound.template_checkout": "Fecha de salida del huésped",
  "outbound.template_status_PENDING":
    "Se están revisando los nuevos cambios de la plantilla. Este proceso puede tardar hasta 24 para que se aprueben los nuevos cambios. No puedes modificar la plantilla enviada hasta que se complete la revisión.",
  "outbound.template_status_REJECTED":
    "Sus cambios han sido rechazados por el siguiente motivo: {reason}",
  "outbound.template_status_LESS_THAN_ONE_DAY":
    "Espere 24 horas desde la última actualización para editar la plantilla nuevamente",
  "outbound.templateReviewTitle":
    "¿Está seguro de que desea enviar estos nuevos cambios para su revisión?",
  "outbound.templateReviewDesc":
    "La revisión puede tardar hasta 24 horas para ser aprobado. No podrá realizar más cambios hasta que finalice la revisión.",
  "outbound.templateSend": "Sí, enviar para revisión",
  "outbound.templateSendForReview":
    "La plantilla se envió a revisión, el proceso de aprobación puede tardar hasta 24 horas",
  "outbound.template_review_url": "Liga para reseñas positivas",
  "outbound.template_review_url_Desc":
    "Se compartira esta liga en caso de que la reseña sea positiva",
  "outbound.template_review_url_Placeholder":
    "https://tripadvisor.com/review/example",
  "outbound.templateNoLang": "Idioma no disponible",
  "outbound.templateNoLangDescription": "Agrega este idioma para empezar",
  "outbound.isLanguageActive": "¿Idioma activo?",
  "onboarding.getStarted": "Comenzar",
  "onboarding.pageTite": "Introducción",
  "onboarding.stepsTitle":
    "Elige un momento para completar tu incorporación a Visito",
  "onboarding.step1":
    "Revisar la información de tu propiedad y la configuración del chat",
  "onboarding.step2":
    "Configurar tus canales de comunicación, incluyendo WhatsApp e Instagram",
  "onboarding.step3": "Resumen de las funciones y capacidades de la cuenta",
  "onboarding.step4":
    "Enviar mensajes de prueba y habilitar Visito en tus propiedades digitales",
  "onboarding.step5": "¡Responder cualquier otra pregunta que puedas tener!",

  "onboarding.businessInfo": "Detalles de tu negocio",
  "onboarding.businessInfoWorking":
    "¡Casi estamos! Esto debería tomar menos de un minuto...",
  "onboarding.businessInfoDone": "Todo listo.",
  "onboarding.businessInfoContinue":
    "Revisar la información y continuar. Siempre puedes editar esto más tarde.",
  "onboarding.channelsDone": "Todo listo!",
  "onboarding.continueToDashboard": "Continuar al dashboard",
  "onboarding.igConnect": "Conectar tu cuenta automáticamente.",
  "onboarding.igConnected": "Tu cuenta de Instagram ha sido conectada.",
  "onboarding.waConnect": "Comienza en minutos.",
  "onboarding.waConnected":
    "Tu número de teléfono de WhatsApp ha sido conectado.",
  "onboarding.channelsTitle": "Conecta Instagram o WhatsApp para empezar:",

  "newConv.Title": "Crear una nueva conversación",
  "newConv.Desc":
    "Ingrese el número de Whatsapp a continuación para crear una nueva conversación.",
  "newConv.invalidPhone": "Parece que has ingresado un número incorrecto.",
  "newConv.success": "Mensaje enviado exitosamente",
  "newConv.invalidFile": "El archivo no es válido",

  "webchat.welcome": "¡Hola! 👋{linebreak}¿En qué podemos ayudarte hoy?",
  "webchat.callPrompt": "Habla con {company}",
};

export default lang;
